import { WebSocketDisconnectReason } from "../../EventEmitter/WebSocketEvents";
export const reasonToStatusCode = (reason) => {
    if (reason === "io client disconnect") {
        return WebSocketDisconnectReason.ClientInitiatedDisconnected;
    }
    else if (reason === "io server disconnect") {
        return WebSocketDisconnectReason.ServerInitiatedDisconnected;
    }
    else if (reason === "ping timeout" || reason === "timeout") {
        return WebSocketDisconnectReason.Timeout;
    }
    else if (reason === "transport close" || reason === "transport error") {
        return WebSocketDisconnectReason.TransportError;
    }
    else if (reason === "bad auth") {
        return WebSocketDisconnectReason.AuthFailure;
    }
    else if (reason === "websocket error") {
        return WebSocketDisconnectReason.WebSocketError;
    }
    return WebSocketDisconnectReason.Unknown;
};
//# sourceMappingURL=socketIOUtils.js.map